import React from 'react';
import "./assets/styles/errormodal.css"
import error from "./assets/images/error.png";

const ErrorModal = ({ message, primaryActionLabel, primaryActionColor, secondaryActionColor, secondaryActionLabel, handleClick }) => {
    return (
        <div className="error-modal">
            <div className="error-modal-content">
                <h4 className="error-modal-heading">
                    <img
                        style={{ width: 25 }}
                        src={error}
                        alt="error"
                    /> <span>Error!</span>
                </h4>
                <p className="error-modal-text">
                    {message}
                </p>
                <div className='actions'>
                    <span className="error-modal-button" onClick={handleClick} style={{ backgroundColor: primaryActionColor }}>{primaryActionLabel}</span>
                    {
                        secondaryActionLabel && <span className="error-modal-button" style={{ backgroundColor: secondaryActionColor }}>{secondaryActionLabel}</span>
                    }
                </div>
            </div>
        </div>
    );
}

export default ErrorModal;
